import classNames from 'classnames'
import type {ReactNode} from 'react'
import React, {memo} from 'react'

import styles from './ParametersPageHeader.css'

interface Props {
  className?: string
  children?: ReactNode
}

function ParametersPageHeaderComponent(props: Props) {
  const {children} = props

  return <div className={classNames(styles.header, props.className)}>{children}</div>
}

export const ParametersPageHeader = memo<Props>(ParametersPageHeaderComponent)
